import { createRoute } from '@tanstack/react-router';
import { adminParentRoute } from 'pages/admin/adminParentRoute';

export const adminFaksRoute = createRoute({
  getParentRoute: () => adminParentRoute,
  path: '/faks',
}).lazy(() => import('pages/admin/Faks/AdminFaksPage/AdminFaksPage').then((d) => d.Route));
